import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useAuth } from '../lib/auth'
import { IdeaCard, type IdeaSummary } from '../components/IdeaCard'

export const Route = createFileRoute('/my-ideas')({
  beforeLoad: async () => {
    const s = useAuth.getState()
    if (s.loading) await s.load()
    if (!useAuth.getState().user) {
      throw redirect({ to: '/login' })
    }
  },
  component: MyIdeasPage,
})

function MyIdeasPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['my-ideas'],
    queryFn: () => api<IdeaSummary[]>('/api/ideas'),
  })

  return (
    <div className="max-w-3xl mx-auto p-8 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-zinc-900 dark:text-zinc-100">Мои идеи</h1>
        <Link
          to="/submit"
          className="px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white rounded-md text-sm"
        >
          + Подать идею
        </Link>
      </div>
      {isLoading && <p className="text-sm text-zinc-500">Загрузка…</p>}
      {error && <p className="text-sm text-red-600">Не удалось загрузить идеи</p>}
      {data && data.length === 0 && (
        <div className="bg-white dark:bg-zinc-800 rounded-2xl border border-zinc-200 dark:border-zinc-700 p-8 text-center">
          <p className="text-zinc-600 dark:text-zinc-400">
            У тебя пока нет поданных идей. Подай первую!
          </p>
        </div>
      )}
      {data && data.length > 0 && (
        <div className="grid grid-cols-1 gap-3">
          {data.map((i) => (
            <IdeaCard key={i.id} idea={i} />
          ))}
        </div>
      )}
    </div>
  )
}
